import { Box } from '@mui/material';
import { JSX, ReactNode, useEffect } from 'react';
import { useGetCurrentAgent, useQueryMe } from '../../hooks/auth';
import LayoutFooter from './layoutFooter';
import LayoutHeader, { DRAWER_WIDTH, LayoutHeaderProps } from './layoutHeader';

// Declare gTM dataLayer array.
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

interface LayoutProps extends Partial<LayoutHeaderProps> {
  children: ReactNode;
}

const Layout = ({ children, breadcrumbs }: LayoutProps): JSX.Element => {
  const { data: agent } = useGetCurrentAgent();
  // Generate GA pageview event
  useEffect(() => {
    window.dataLayer?.push({ event: 'pageview', user_id: agent?.username });
  }, []);

  return (
    <Box
      className="min-h-screen pb-12 flex flex-col"
      sx={{ marginLeft: { sm: `${DRAWER_WIDTH}px` } }}
    >
      <LayoutHeader breadcrumbs={breadcrumbs} />
      <Box className="flex-grow">{children}</Box>
      <LayoutFooter />
    </Box>
  );
};
export default Layout;
